import { StanTipTapEditor } from '@/components';
import { SectionHeader } from './SectionHeader';

interface TopBannerSectionProps {
    sectionNumber: number;
    value: string;
    onChange: (next: string) => void;
    disabled?: boolean;
}

export const TopBannerSection = ({ sectionNumber, value, onChange, disabled }: TopBannerSectionProps) => (
    <div className='flex flex-col gap-4 md:gap-6'>
        <SectionHeader number={sectionNumber} title='Top Banner' />
        <div className='flex flex-col gap-2'>
            <p className='text-body-sm text-dark'>Customize your banner text</p>
            <StanTipTapEditor
                value={value}
                onChange={onChange}
                imageUploadAllowed={false}
                videoAllowed={false}
                generateAiAllowed={false}
                allowAddProductLink={false}
                disabled={disabled}
                placeholder='Write something to grab your visitor’s attention...'
            />
        </div>
    </div>
);
